import { render, staticRenderFns } from "./suggestionsListSideBar.vue.html?vue&type=template&id=77aa6c52&"
import script from "./suggestionsListSideBar.ts?vue&type=script&lang=ts&"
export * from "./suggestionsListSideBar.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports